const styles = ({ COLORS }) => ({
  link: {
    textDecoration: 'none',
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL
  }
})

export default styles
